export default {
  signup: {
    my_comp_exhibiting: '当社はこのイベントに出展します',
    sur_un_stand_individual: '個別またはシェアブース（Business France経由）',
    sur_un_stand_collectif: '地域または業界団体の共同ブース',
    selecting_event: 'イベントを選択',
    selecting_collectif: '共同出展団体を選択',
    title: 'ロワールワイン商談試飲会 輸入業者登録',
    subtitle: 'アカウント作成申請：',
    form: {
      text: {
        bold: 'ログイン作成の担当者 > ',
        normal: '情報は販促物には表示されません**',
      },
      labels: {
        firstname: '名',
        lastname: '姓',
        phone: '電話番号',
        companyName: '会社名',
        siret: 'ABN',
        email: 'メールアドレス／ログインID',
        password: 'パスワードを設定',
        passwordConfirmation: 'パスワードを再入力',
      },
      validate: '確定',
      asterix: {
        required: '必須情報',
        info: '上記の情報は、貴社のアカウントとログイン情報の作成に使用されます。この情報は公開されず、ファイル管理のために保管されます。（メールアドレス1つにつき1社のアカウント）',
      },
      success:
        '数分後にアカウント確認用のメールが届きます。迷惑メールフォルダもご確認ください',
    },
    category_of_my_company: '当社のカテゴリ',
    select_category: 'カテゴリを選択',
  },
};
